__turbopack_context__.v({
  "copyButton": "CopyButton-module__gUQ-Ka__copyButton",
});
